import type { OpeningHoursV1Attributes } from '@/features/opening-hours-v1/opening-hours-v1-type';

import { IconImage } from '@/core/features';
import { useDeviceoutput } from '@/core/features/cookies/use-device-output';

type OpeningHoursV1Props = OpeningHoursV1Attributes;

export default function OpeningHoursV1({ footer, iconUrl, openingHours }: OpeningHoursV1Props) {
    const { isDesktopView } = useDeviceoutput();
    return (
        <div>
            <div className={`flex ${isDesktopView ? 'gap-10' : 'gap-8'}`}>
                <IconImage
                    height={18}
                    url={iconUrl}
                    width={18}
                />
                <div className={`flex-column ${isDesktopView ? 'gap-10' : 'gap-8'} width-100`}>
                    {openingHours.map(({ periods, weekday }, index) => (
                        <div
                            className={'width-100 flex gap-10'}
                            key={`${weekday} ${index}`}
                        >
                            <div
                                // eslint-disable-next-line no-inline-styles/no-inline-styles
                                style={{ minWidth: periods.length === 0 ? '100%' : 82 }}
                            >
                                {weekday}
                            </div>
                            <div className={'flex-column width-100 row-gap-5 align-start'}>
                                {periods.map(({ text }, periodIndex) => (
                                    <div key={`${text} ${periodIndex}`}>{text}</div>
                                ))}
                            </div>
                        </div>
                    ))}
                    {footer && <div>{footer.text}</div>}
                </div>
            </div>
        </div>
    );
}
